import { createSlice } from '@reduxjs/toolkit';

import { IEvents, IScene } from '@/interface';


export interface PreviewState {
  mission?: { scene: Partial<IScene>, mission: IEvents[] }
}

const initialState: PreviewState = {
};

export const preview = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    changeMissionPreview(state, action: { payload: { scene: Partial<IScene>, mission: IEvents[] } | undefined }) {
      return {
        ...state,
        mission: action.payload,
      };
    },
  },
});

export const { changeMissionPreview } = preview.actions;

export default preview.reducer;
